import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import Attachments from 'components/attachments/file_system';
import Card from 'bundles/apex/card';
import AttachmentControls from './attachment_controls';
import NoPreview from './no_preview';

import { addAttachment, setAttachmentFolders, setAttachments } from 'bundles/apex/deals/show/store/deal/actions';
import { loadRelatedDeals } from 'bundles/apex/deals/show/store/related_deals/actions';

import './styles.scss';

export function DealAttachments({
  addAttachment,
  deal,
  forUser,
  setAttachmentFolders,
  setAttachments,
}) {
  return (
    <div className="deal-attachments-v2">
      <Card
        controls={<AttachmentControls attachmentsArchivePath={deal.attachmentsArchivePath} />}
        fullWidth
        label="Attachments"
      >
        <div className="w-100">
          <Attachments
            allowDeletion={forUser.canDeleteAttachments}
            attachable={{
              attachmentFoldersPath: deal.attachmentFoldersPath,
              id: deal.voucherId,
              type: 'Backoffice::Voucher',
            }}
            attachments={deal.attachments}
            folders={deal.attachmentFolders}
            forUserId={forUser.id}
            noPreviewComponent={NoPreview}
            preview
            onAttachmentCreated={addAttachment}
            onAttachmentsChange={setAttachments}
            onFoldersChange={setAttachmentFolders}
          />
        </div>
      </Card>
    </div>
  );
}

DealAttachments.propTypes = {
  addAttachment: PropTypes.func.isRequired,
  attachmentsPath: PropTypes.string.isRequired,
  deal: PropTypes.shape({
    attachments: PropTypes.array.isRequired,
    attachmentsArchivePath: PropTypes.string.isRequired,
    attachmentFolders: PropTypes.array.isRequired,
    voucherId: PropTypes.number.isRequired,
  }).isRequired,
  forUser: PropTypes.shape({
    canDeleteAttachments: PropTypes.bool.isRequired,
    id: PropTypes.number.isRequired,
  }),
  setAttachmentFolders: PropTypes.func.isRequired,
  setAttachments: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  attachmentsPath: state.paths.attachments,
  features: state.features,
  forUser: state.forUser,
  deal: state.deal,
  loading: state.relatedDeals.loading,
});

const mapDispatchToProps = {
  addAttachment,
  loadRelatedDeals,
  setAttachmentFolders,
  setAttachments,
};

export default connect(mapStateToProps, mapDispatchToProps)(DealAttachments);
